import people from '@/assets/people.png';
import buildMemberProfiles from '../buildMemberProfiles';
import { envConfig } from '../../../config/env';

const { cdnBase } = envConfig;

const getPhoto = (slug) => {
  try {
    return `${cdnBase}/members/${slug}.jpg`;
  } catch (error) {
    return people;
  }
};

export default {
    // 固定
    breadcrumb: {
      home: '首页',
      current: '团队成员',
    },
    // 固定
    profileLabels: {
      biography: '个人简介',
      affiliation: '所属机构',
      contacts: '联系与链接',
    },
    // 固定
    profileFallback: {
      heading: '成员信息缺失',
      message: '未找到该成员信息，可能已移动或正在更新中。',
      actions: {
        members: '返回成员列表',
        home: '返回首页',
      },
    },
    // 成员列表与详情（统一数据来源）
    ...(() => {
      const roster = [
        {
          heading: '教师',
          members: [
            {
              slug: 'gao-boyu',
              name: '高博宇',
              title: '博士生导师',
              note: '虚拟现实，人机交互，人工智能与智慧教育，应用安全',
              image: getPhoto('gao-boyu'),
              profile: {
                summary: '虚拟现实，人机交互，人工智能与智慧教育，应用安全',
                affiliation: {
                  role: '',
                  institution: '暨南大学网络空间安全学院，广东智慧教育研究院',
                },
                bio: [
                  '高博宇，暨南大学网络空间安全学院副教授、硕导、广东智慧教育研究院院长助理，从2011-起在韩国建国大学DCRC研究中心(主任:Jee-InKim教授、CHI2015LocalHero)与VR实验室(主任:HyungSeokKim教授，指导教授)从事虚拟现实多通道可信交互相关研究，作为核心成员参与了多项韩国自然科学基金重点研发计划项目，2018-2博士毕业后留校工作半-，同-9以副教授入职暨南大学，主持国家自然科学基金面上项目、国家重点研发计划项目子课题、国家自然科学基金青-项目、广东省自然科学基金面上项目、广州市基础与应用基础研究青-项目、企业合作项目等10余项科研项目。',
                  '已发表国际期刊与会议论文30余篇，其中以第一或通讯作者身份发表26篇SCI索引/CCF列表期刊会议论文，包括IEEEVR(CCF-A类会议)、IEEETransactionsonVisualizationandComputerGraphics(CCF-A类期刊)、InternationalJournalofHuman-ComputerStudies(CCF-A类期刊)、IEEETransationsonHuman-MachineSystems(CCF-B类期刊)、InternationalJournalofHuman-ComputerInteraction(CCF-B类期刊)、以及计算机应用类期刊IEEETrans.IndustrialInformatics(中科院一区Top)等。获得HHME2023CHCI最佳论文奖，韩国计算机大会2019-最佳论文奖、2019-度吴渔夫科技创新育人奖、2021-度广东省计算机学会科学进步奖三等奖等。'
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:bygao@jnu.edu.cn', icon: 'mail' },
                  {
                    label: '谷歌学术',
                    url: 'https://scholar.google.com/citations?user=mXbw1cAAAAAJ&hl=en',
                    icon: 'scholar',
                  },
                ],
              },
            },
            {
              slug: 'wan-tingjie',
              name: '万婷洁',
              title: '讲师',
              note: '虚拟现实，人机交互，交互设计，智慧教育',
              image: getPhoto('wan-tingjie'),
              profile: {
                summary: '虚拟现实，人机交互，交互设计，智慧教育',
                affiliation: {
                  role: '',
                  institution: '广东智慧教育研究院',
                },
                bio: [
                  '万婷洁，暨南大学广东智慧教育研究院讲师，青蓝学者。万婷洁博士在利物浦大学取得计算机科学与软件工程专业博士，主要研究方向是虚拟现实(VR)与人机交互(HCI)，以及在教育场景的应用。在CHI (CCF-A类会议)，TVCG (CCF-A类期刊)，IEEE VR (CCF-A类会议)，IEEE ISMAR (CCF-B类会议)等人机交互领域顶级会议和期刊上发表多篇论文。获得ISMAR 2024最佳论文提名。'
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:tjwan@jnu.edu.cn', icon: 'mail' },
                  {
                    label: '谷歌学术',
                    url: 'https://scholar.google.com/citations?user=HdKn7xcAAAAJ&hl=en',
                    icon: 'scholar',
                  },
                ],
              },
            },
          ],
        },
        {
          heading: '学生',
          members: [
            {
              slug: 'mai-zijun',
              name: '麦紫君',
              title: '博士研究生',
              note: '虚拟现实',
              image: getPhoto('mai-zijun'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:zijunmai@stu2023.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'li-binghui',
              name: '李炳辉',
              title: '博士研究生',
              note: '虚拟现实',
              image: getPhoto('li-binghui'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:libinghui927@gmail.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'pan-jian',
              name: '潘健',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('pan-jian'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:1289682586@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'ye-guanyu',
              name: '叶冠宇',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('ye-guanyu'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'ma-qizi',
              name: '马琪姿',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('ma-qizi'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:1272298369@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'yu-yongsong',
              name: '余泳松',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('yu-yongsong'),

              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:153481783@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'yang-jianwei',
              name: '杨剑玮',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('yang-jianwei'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:2425375336@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zheng-zibo',
              name: '郑子博',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('zheng-zibo'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:qitiantaile@stu2024.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'tan-minming',
              name: '谭民明',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('tan-minming'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chi-junlin',
              name: '池俊林',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('chi-junlin'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:2623135403@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'wu-yizhi',
              name: '吴易之',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('wu-yizhi'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:17538569450@163.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'guo-yingxin',
              name: '郭英新',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('guo-yingxin'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:2414474238@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zhou-jungu',
              name: '周峻谷',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('zhou-jungu'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:2432153945@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chen-yiming',
              name: '陈一铭',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('chen-yiming'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:whitebiana@gmail.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'fang-sicheng',
              name: '方思成',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('fang-sicheng'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:3152941441@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'xiong-jufeng',
              name: '熊钜锋',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('xiong-jufeng'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:jfxiong@stu2025.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chen-zexi',
              name: '陈泽熙',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('chen-zexi'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:3131652317@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'wang-chunlin',
              name: '王春霖',
              title: '本科生',
              note: '虚拟现实 ',
              image: getPhoto('wang-chunlin'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:3482372203@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'deng-yalin',
              name: '邓亚琳',
              title: '本科生',
              note: '虚拟现实 ',
              image: getPhoto('deng-yalin'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:1553552285@qq.com', icon: 'mail' },
                ],
              },
            },
          ],
        },
        {
          heading: '毕业生',
          members: [
            {
              slug: 'mai-zijun',
              name: '麦紫君',
              title: '硕士研究生',
              note: '虚拟现实',
              image: getPhoto('mai-zijun'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:zijunmai@stu2023.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'wang-miao',
              name: '王渺',
              title: '硕士研究生',
              note: '虚拟现实',
              image: getPhoto('wang-miao'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'bu-zongyong',
              name: '卜宗勇',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('bu-zongyong'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'shao-tong',
              name: '邵同',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('shao-tong'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:bruceshaot@163.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'huang-zexin',
              name: '黄泽鑫',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('huang-zexin'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'gao-yadian',
              name: '高雅典',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('gao-yadian'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'sun-weili',
              name: '孙伟力',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('sun-weili'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:swwwish@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zheng-haojun',
              name: '郑浩军',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('zheng-haojun'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'xin-weiqiang',
              name: '辛威强',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('xin-weiqiang'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'feng-jiana',
              name: '冯嘉娜',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('feng-jiana'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:1132176251@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'he-yidang',
              name: '何一当',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('he-yidang'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:15919662362@163.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'li-dasheng',
              name: '李达升',
              title: '硕士研究生',
              note: '虚拟现实 ',
              image: getPhoto('li-dasheng'),
              profile: {
                summary: '虚拟现实',
                affiliation: {
                  role: '',
                  institution: '暨南大学 VR实验室',
                },
                bio: [
                ],
                contacts: [
                  { label: '邮箱', url: 'mailto:3489988586@qq.com', icon: 'mail' },
                ],
              },
            },
          ],
        },
      ];
      return {
        roster,
        profiles: buildMemberProfiles(roster),
      };
    })(),
    // 成员去向
    alumni: {
      heading: '校友',
      columns: {
        name: '姓名',
        role: '角色',
        period: '在组时间',
        destination: '去向',
      },
      people: [
        {
          name: '冯嘉娜',
          role: '硕士研究生',
          period: '2023.09 - 2025.07',
          destination: '百度',
        },
      ],
    },
  };
